export function controlCenterDeactivateServerModel(data) {
  return {
    ControlCenterId: data.controlCenterId,
    MoveDataToControlCenterId: data.moveDataToControlCenterId,
	BackUpControlCenterId: data.backUpControlCenterId,
    EnableSchedule: data.enable_schedule,
    Schedule: data.schedule,
  };
}
